import { useLang } from "../i18n/LanguageContext";
import { GiScrollUnfurled, GiBookmarklet } from "react-icons/gi";

export const InterpretationPanel = ({ loading, result }) => {
  const { t } = useLang();
  const symbols = Array.isArray(result?.symbols) ? result.symbols.filter(Boolean) : [];
  const hasSymbols = symbols.length > 0;

  return (
    <div
      className="ornate-frame bg-parchment-dark p-1 fade-up"
      data-testid="interpretation-panel"
    >
      <div className="bg-parchment p-8 md:p-12">
        <div className="flex items-center gap-3 text-gold-muted">
          <GiScrollUnfurled className="text-2xl" />
          <span className="font-accent text-[11px] uppercase tracking-[0.3em]">
            {t.interpretation.subtitle}
          </span>
        </div>

        <h2
          className="font-heading italic text-3xl md:text-4xl text-ink mt-2"
          data-testid="interpretation-title"
        >
          {t.interpretation.title}
        </h2>

        <div className="divider-ornate mt-8" />

        {loading ? (
          <div
            className="py-12 text-center font-heading italic text-xl text-ink-soft"
            data-testid="interpretation-loading"
          >
            <span className="inline-block animate-pulse">
              {t.hero.loading}
            </span>
          </div>
        ) : (
          result && (
            <div className="mt-8">
              {hasSymbols && (
                <div>
                  <div className="font-accent text-[11px] uppercase tracking-[0.25em] text-ink-soft">
                    {t.interpretation.symbolsTitle}
                  </div>
                  <div
                    className="mt-4 flex flex-wrap gap-2"
                    data-testid="symbol-chips"
                  >
                    {symbols.map((s, i) => (
                      <span
                        key={i}
                        className="inline-flex items-center px-3 py-1.5 border border-gold-muted text-ink bg-parchment text-xs font-accent uppercase tracking-[0.18em]"
                        data-testid={`symbol-chip-${i}`}
                      >
                        {s}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              <div className={hasSymbols ? "mt-10" : "mt-2"}>
                <div className="font-accent text-[11px] uppercase tracking-[0.25em] text-ink-soft">
                  {t.interpretation.readingTitle}
                </div>
                <p
                  className="mt-4 font-body text-lg leading-relaxed text-ink first-letter:font-heading first-letter:text-5xl first-letter:font-medium first-letter:float-left first-letter:mr-2 first-letter:leading-none first-letter:text-gold-muted"
                  data-testid="interpretation-body"
                >
                  {result.body}
                </p>
              </div>

              <div className="mt-12 pt-8 border-t border-ink/10" data-ui="guest-reading-register-cta">
                <div className="font-accent text-[11px] uppercase tracking-[0.3em] text-gold-muted">
                  {t.interpretation.guestCtaEyebrow}
                </div>
                <h3 className="mt-3 font-heading italic text-2xl md:text-3xl text-ink leading-tight">
                  {t.interpretation.guestCtaTitle}
                </h3>
                <p className="mt-4 font-body text-base leading-relaxed text-ink-soft">
                  {t.interpretation.guestCtaBody}
                </p>
                <div className="mt-7 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                  <a
                    href="#/rejestracja"
                    data-testid="save-codex-btn"
                    className="group relative inline-flex items-center justify-center gap-3 bg-ink text-gold px-8 py-4 font-accent text-[11px] uppercase tracking-[0.25em] hover:bg-ink-deep hover:text-gold-light transition-colors border border-gold/30 hover:border-gold/60 shadow-[0_0_28px_rgba(201,161,91,0.12)]"
                  >
                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-gold opacity-70" />
                    <GiBookmarklet className="text-base" />
                    {t.interpretation.guestCtaButton}
                  </a>
                  <div className="font-body italic text-xs text-ink-soft sm:text-right max-w-xs">
                    {t.interpretation.guestCtaHint}
                  </div>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};
